import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { getIcon } from "../lib/icons";
import { ArrowRight } from "lucide-react";

export default function Services() {
  const { t, dir } = useLang();
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";

  return (
    <div>
      <PageHero tag={t.servicesSection.tag} title={t.servicesSection.title} desc={t.whatWeDo.desc} />
      <section className="py-12 rq-light">
        <div className="rq-container grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {t.servicesList.map((s, i) => {
            const Icon = getIcon(s.icon);
            const isCyber = s.slug === "cyber-security";
            const cardInner = (
              <>
                <div className="grid place-items-center h-14 w-14 rounded-xl bg-[rgba(46,230,110,0.12)] text-[color:var(--rq-green)] transition-transform duration-300 group-hover:scale-110">
                  <Icon size={26} />
                </div>
                <h3 className="font-display mt-5 text-xl font-semibold text-white">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--rq-muted)]">{s.short}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--rq-green)]">
                  {t.servicesSection.cta}
                  <ArrowRight size={15} style={{ transform: flip }} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </>
            );
            return (
              <Reveal key={s.slug} delay={(i % 3) * 100}>
                {isCyber ? (
                  <a
                    href="https://cyberquess.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rq-card p-8 h-full block group"
                    data-testid={`service-card-${s.slug}`}
                  >
                    {cardInner}
                  </a>
                ) : (
                  <Link to={`/services/${s.slug}`} className="rq-card p-8 h-full block group" data-testid={`service-card-${s.slug}`}>
                    {cardInner}
                  </Link>
                )}
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
